import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  options: {
    marginTop: 16
  }
})
